import React from 'react';

import i18n from '../utils/i18n';

interface DialogParams {
    title?: string;
    message?: React.ReactNode;
    cancelText?: React.ReactNode;
    okText?: React.ReactNode;
    okCallback?: (() => void) | null;
}

const useDialog = () => {
    const defaultParams: DialogParams = {
        title: '',
        message: '',
        cancelText: i18n('cancel'),
        okText: i18n('ok'),
        okCallback: null
    };
    const [isShowAlert, setIsShowAlert] = React.useState(false);
    const [alertData, setAlertData] = React.useState<DialogParams>({});

    const handleAlert = (params?: DialogParams) => {
        if (params?.message || params?.title) {
            setAlertData({ ...defaultParams, ...params });
            setIsShowAlert(true);
        } else {
            setIsShowAlert(false);
        }
    };

    return { isShowAlert, handleAlert, alertData };
};

export default useDialog;
